class Elements extends React.Component {
  render() {
    return(
      <ul className="section__items--elements">
        <Button />
        <Checkbox />
        <Radio />
        <Select />
        <Switch />
        <Table />
        <Textfield />
        <Textarea />
      </ul>
    )
  }
};
